const css = `
  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  :root {
    --wood-dark: #3B2A1A;
    --wood-mid: #7C5A35;
    --wood-light: #C49A6C;
    --cream: #F5EFE6;
    --white: #FDFAF7;
    --text-dark: #2C1E0F;
    --text-muted: #7A6150;
  }

  html, body, #root {
    margin: 0; padding: 0; width: 100%; min-height: 100vh;
  }

  body {
    font-family: 'Jost', sans-serif;
    background: var(--white);
    color: var(--text-dark);
    overflow-x: hidden;
  }

  /* ── NAV ── */
  nav {
    position: fixed; top: 0; width: 100%; z-index: 200;
    background: rgba(253,250,247,0.95);
    backdrop-filter: blur(10px);
    border-bottom: 1px solid rgba(196,154,108,0.2);
    display: flex; align-items: center; justify-content: space-between;
    padding: 0 60px; height: 70px;
  }
  .logo-link {
    display: flex; align-items: center; text-decoration: none; cursor: pointer;
  }
  .nav-logo {
    height: 52px; width: 52px; object-fit: contain; transition: transform 0.3s;
  }
  .nav-logo:hover { transform: rotate(8deg) scale(1.08); }

  .footer-logo-link {
    display: flex; align-items: center; text-decoration: none;
  }
.footer-logo-img { height: 54px; width: 54px; object-fit: contain; opacity: 0.9; transition: opacity 0.3s, transform 0.3s; }
  .footer-logo-img:hover { opacity: 1; transform: scale(1.05); }

  .nav-links { display: flex; gap: 32px; list-style: none; }
  .nav-links a {
    text-decoration: none; font-size: 12px; font-weight: 400;
    letter-spacing: 1.5px; text-transform: uppercase;
    color: var(--text-muted); transition: color 0.3s;
  }
  .nav-links a:hover, .nav-links a.active { color: var(--wood-dark); }

  .nav-cta {
    background: var(--wood-dark); color: var(--cream);
    font-family: 'Jost', sans-serif; font-size: 12px;
    letter-spacing: 1.5px; text-transform: uppercase;
    padding: 10px 22px; border: none; cursor: pointer; transition: background 0.3s;
  }
  .nav-cta:hover { background: var(--wood-mid); }

  .hamburger {
    display: none; flex-direction: column; gap: 5px;
    background: none; border: none; cursor: pointer; padding: 4px;
  }
  .hamburger span {
    display: block; width: 24px; height: 2px;
    background: var(--wood-dark); transition: all 0.3s;
  }
  .hamburger.open span:nth-child(1) { transform: translateY(7px) rotate(45deg); }
  .hamburger.open span:nth-child(2) { opacity: 0; }
  .hamburger.open span:nth-child(3) { transform: translateY(-7px) rotate(-45deg); }

  .mobile-menu {
    display: none; position: fixed; top: 70px; left: 0; right: 0;
    background: var(--white); z-index: 199;
    border-bottom: 1px solid rgba(196,154,108,0.2);
    flex-direction: column; padding: 24px 32px; gap: 20px;
  }
  .mobile-menu.open { display: flex; }
  .mobile-menu a {
    text-decoration: none; font-size: 14px; letter-spacing: 1.5px;
    text-transform: uppercase; color: var(--text-muted);
    padding: 8px 0; border-bottom: 1px solid rgba(196,154,108,0.1);
  }
  .mobile-menu a:hover { color: var(--wood-dark); }
  .mobile-menu .nav-cta { margin-top: 8px; text-align: center; }

  /* ── SHARED SECTION STYLES ── */
  .section { padding: 120px 60px; }
  .section-tag {
    font-size: 11px; letter-spacing: 3px; text-transform: uppercase;
    color: var(--wood-light); margin-bottom: 16px;
  }
  .section-title {
    font-family: 'Playfair Display', serif; font-size: 48px;
    line-height: 1.2; color: var(--wood-dark); font-weight: 600; margin-bottom: 20px;
  }
  .section-sub {
    font-size: 16px; color: var(--text-muted); line-height: 1.8; max-width: 560px;
  }

  /* ── PAGE HERO BANNER ── */
  .page-hero {
    min-height: 340px; display: flex; align-items: flex-end;
    background: linear-gradient(135deg, var(--wood-dark) 0%, #5C3D20 55%, #8B5E3C 100%);
    padding: 70px 60px 64px; position: relative; overflow: hidden;
  }
  .page-hero::before {
    content:''; position:absolute; inset:0;
    background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none'%3E%3Cg fill='%23ffffff' fill-opacity='0.03'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  }
  .page-hero-content { position: relative; }
  .page-hero-tag {
    font-size: 11px; letter-spacing: 3px; text-transform: uppercase;
    color: var(--wood-light); margin-bottom: 16px;
  }
  .page-hero h1 {
    font-family: 'Playfair Display', serif; font-size: 56px;
    color: var(--cream); font-weight: 700; line-height: 1.1;
  }
  .page-hero h1 em { color: var(--wood-light); font-style: italic; }

  /* ── BUTTONS ── */
  .btn-primary {
    background: var(--wood-light); color: var(--wood-dark);
    padding: 16px 36px; font-family: 'Jost', sans-serif; font-size: 13px;
    letter-spacing: 1.5px; text-transform: uppercase; font-weight: 500;
    border: none; cursor: pointer; transition: all 0.3s; display: inline-block;
  }
  .btn-primary:hover { background: var(--cream); }
  .btn-outline {
    background: transparent; color: var(--cream); padding: 16px 36px;
    font-family: 'Jost', sans-serif; font-size: 13px; letter-spacing: 1.5px;
    text-transform: uppercase; font-weight: 400;
    border: 1px solid rgba(245,239,230,0.4); cursor: pointer; transition: all 0.3s;
  }
  .btn-outline:hover { border-color: var(--cream); }
  .btn-dark {
    background: var(--wood-dark); color: var(--cream);
    padding: 14px 32px; font-family: 'Jost', sans-serif; font-size: 12px;
    letter-spacing: 1.5px; text-transform: uppercase;
    border: none; cursor: pointer; transition: background 0.3s;
  }
  .btn-dark:hover { background: var(--wood-mid); }

  /* ── HOME: HERO ── */
  .hero {
    min-height: 100vh; display: flex; align-items: center;
    background: linear-gradient(135deg, var(--wood-dark) 0%, #5C3D20 50%, #8B5E3C 100%);
    position: relative; overflow: hidden; padding: 70px 60px 0;
  }
  .hero::before {
    content: ''; position: absolute; inset: 0;
    background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.03'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  }
  .hero-content { position: relative; max-width: 50%; animation: fadeUp 1s ease both; }
  .hero-badge {
    display: inline-block; font-size: 11px; letter-spacing: 3px;
    text-transform: uppercase; color: var(--wood-light);
    border: 1px solid rgba(196,154,108,0.4); padding: 6px 18px; margin-bottom: 32px;
  }
  .hero h1 {
    font-family: 'Playfair Display', serif; font-size: 68px;
    line-height: 1.1; color: var(--cream); font-weight: 700; margin-bottom: 24px;
  }
  .hero h1 em { color: var(--wood-light); font-style: italic; }
  .hero-desc {
    font-size: 17px; color: rgba(245,239,230,0.7); line-height: 1.8;
    max-width: 480px; margin-bottom: 48px; font-weight: 300;
  }
  .hero-btns { display: flex; gap: 16px; flex-wrap: wrap; }
  .hero-img {
    position: absolute; right: 0; top: 0; bottom: 0; width: 50%;
    background: linear-gradient(to right, #5C3D20, #8B5E3C); overflow: hidden;
  }
  .wood-rings {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%); width: 500px; height: 500px;
  }
  .hero-stats {
    display: flex; gap: 48px; margin-top: 64px; padding-top: 48px;
    border-top: 1px solid rgba(196,154,108,0.2); flex-wrap: wrap;
  }
  .stat-num {
    font-family: 'Playfair Display', serif; font-size: 36px;
    color: var(--wood-light); font-weight: 600;
  }
  .stat-label {
    font-size: 12px; color: rgba(245,239,230,0.5);
    letter-spacing: 1px; text-transform: uppercase; margin-top: 4px;
  }

  /* ── HOME: SERVICES PREVIEW ── */
  .services-header { display: flex; justify-content: space-between; align-items: flex-end; gap: 24px; }
  .services-grid {
    display: grid; grid-template-columns: repeat(3, 1fr);
    gap: 2px; margin-top: 64px; background: var(--cream);
  }
  .service-card {
    background: var(--white); padding: 48px 36px;
    transition: all 0.4s; cursor: pointer; position: relative; overflow: hidden;
  }
  .service-card::after {
    content: ''; position: absolute; bottom: 0; left: 0;
    width: 0; height: 3px; background: var(--wood-light); transition: width 0.4s;
  }
  .service-card:hover::after { width: 100%; }
  .service-card:hover { background: var(--cream); }
  .service-icon { font-size: 36px; margin-bottom: 24px; }
  .service-card h3 {
    font-family: 'Playfair Display', serif; font-size: 22px;
    color: var(--wood-dark); margin-bottom: 16px; font-weight: 600;
  }
  .service-card p { font-size: 14px; color: var(--text-muted); line-height: 1.8; }
  .arrow { margin-top: 32px; font-size: 13px; color: var(--wood-light); letter-spacing: 1px; }

  /* ── HOME: ABOUT PREVIEW ── */
  .about-bg { background: var(--cream); }
  .about-inner { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; }
  .about-visual { position: relative; }
  .wood-block {
    width: 100%; aspect-ratio: 4/5;
    background: linear-gradient(135deg, var(--wood-dark) 0%, var(--wood-mid) 60%, var(--wood-light) 100%);
    position: relative; overflow: hidden;
  }
  .wood-block::before {
    content: ''; position: absolute; inset: 0;
    background: repeating-linear-gradient(0deg, transparent, transparent 20px, rgba(255,255,255,0.03) 20px, rgba(255,255,255,0.03) 21px);
  }
  .wood-block-text {
    position: absolute; bottom: 40px; left: 40px;
    font-family: 'Playfair Display', serif; font-size: 48px;
    color: rgba(245,239,230,0.15); font-weight: 700; line-height: 1;
  }
  .wood-block-accent {
    position: absolute; bottom: -20px; right: -20px;
    width: 65%; aspect-ratio: 1; background: var(--wood-light); opacity: 0.15;
  }
  .iso-badge {
    position: absolute; top: 32px; right: -16px;
    background: var(--wood-dark); color: var(--cream); padding: 24px 28px;
  }
  .iso-num { font-family: 'Playfair Display', serif; font-size: 28px; color: var(--wood-light); font-weight: 600; }
  .iso-label { font-size: 12px; color: rgba(245,239,230,0.6); margin-top: 4px; letter-spacing: 1px; }
  .about-title { font-size: 38px !important; }
  .about-desc { color: var(--text-muted); font-size: 15px; line-height: 1.9; margin-top: 20px; }
  .feature-list { margin-top: 40px; display: flex; flex-direction: column; gap: 24px; }
  .feature-item { display: flex; gap: 16px; align-items: flex-start; }
  .feature-dot { width: 6px; height: 6px; border-radius: 50%; background: var(--wood-light); margin-top: 8px; flex-shrink: 0; }
  .feature-item h4 { font-size: 15px; font-weight: 500; color: var(--wood-dark); margin-bottom: 4px; }
  .feature-item p { font-size: 13px; color: var(--text-muted); line-height: 1.7; }

  /* ── HOME: PRODUCTS PREVIEW ── */
  .products-header { display: flex; justify-content: space-between; align-items: flex-end; gap: 16px; }
  .btn-all {
    background: transparent; border: 1px solid rgba(196,154,108,0.4);
    padding: 12px 28px; font-family: 'Jost', sans-serif; font-size: 12px;
    letter-spacing: 1.5px; text-transform: uppercase; cursor: pointer;
    color: var(--text-muted); transition: all 0.3s; white-space: nowrap;
  }
  .btn-all:hover { border-color: var(--wood-light); color: var(--wood-dark); }
  .products-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 24px; margin-top: 64px; }
  .product-card { overflow: hidden; cursor: pointer; transition: transform 0.4s ease, box-shadow 0.4s ease; }
  .product-card:hover { transform: scale(1.03) translateY(-6px); box-shadow: 0 20px 48px rgba(0,0,0,0.18); }
  .product-img { aspect-ratio: 3/4; overflow: hidden; }
  .product-color {
    width: 100%; height: 100%; transition: transform 0.6s;
    display: flex; align-items: flex-end; padding: 24px;
    font-family: 'Playfair Display', serif; font-size: 18px; font-weight: 600; color: var(--cream);
  }
  .p1 { background: linear-gradient(180deg,#6B3F1F 0%,#3B2A1A 100%); }
  .p2 { background: linear-gradient(180deg,#9E6B3F 0%,#5C3D20 100%); }
  .p3 { background: linear-gradient(180deg,#C49A6C 0%,#8B5E3C 100%); }
  .p4 { background: linear-gradient(180deg,#8B5E3C 0%,#4A2C0F 100%); }
  .product-info { padding: 16px 0; }
  .product-info h4 { font-size: 15px; font-weight: 500; color: var(--wood-dark); }
  .product-info p { font-size: 12px; color: var(--text-muted); margin-top: 4px; }

  /* ── TESTIMONIAL ── */
  .testimonial { background: var(--wood-dark); padding: 0 60px; height: 480px; display: flex; align-items: center; justify-content: center; }
  .testimonial-inner { max-width: 800px; width: 100%; text-align: center; }
  .quote-mark {
    font-family: 'Playfair Display', serif; font-size: 140px;
    color: var(--wood-light); opacity: 0.5; line-height: 0.5; margin-bottom: 32px;
  }
  .testimonial-text {
    font-family: 'Playfair Display', serif; font-size: 28px;
    color: var(--cream); line-height: 1.6; font-style: italic; margin-bottom: 40px;
  }
  .testimonial-author { font-size: 15px; color: var(--wood-light); letter-spacing: 2px; text-transform: uppercase; text-align: center; }

  /* ── CONTACT FORM ── */
  .contact-inner { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; }
  .contact-title { font-size: 38px !important; }
  .contact-desc { color: var(--text-muted); font-size: 15px; line-height: 1.8; margin-top: 20px; }
  .contact-detail { margin-top: 40px; display: flex; flex-direction: column; gap: 24px; }
  .contact-row { display: flex; gap: 16px; align-items: flex-start; }
  .contact-icon {
    width: 40px; height: 40px; border: 1px solid rgba(196,154,108,0.3);
    display: flex; align-items: center; justify-content: center;
    font-size: 16px; flex-shrink: 0;
  }
  .contact-row h5 { font-size: 12px; letter-spacing: 1.5px; text-transform: uppercase; color: var(--text-muted); margin-bottom: 4px; }
  .contact-row p { font-size: 15px; color: var(--wood-dark); }
  .contact-form { display: flex; flex-direction: column; gap: 16px; }
  .form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
  .form-group { display: flex; flex-direction: column; gap: 8px; }
  .form-group label { font-size: 11px; letter-spacing: 1.5px; text-transform: uppercase; color: var(--text-muted); }
  .form-group input, .form-group select, .form-group textarea {
    background: var(--cream); border: 1px solid rgba(196,154,108,0.3);
    padding: 14px 16px; font-family: 'Jost', sans-serif; font-size: 14px;
    color: var(--wood-dark); outline: none; transition: border-color 0.3s;
    resize: none; width: 100%;
  }
  .form-group input:focus, .form-group select:focus, .form-group textarea:focus { border-color: var(--wood-light); }
  .form-submit {
    background: var(--wood-dark); color: var(--cream); padding: 16px;
    font-family: 'Jost', sans-serif; font-size: 13px; letter-spacing: 2px;
    text-transform: uppercase; border: none; cursor: pointer;
    transition: background 0.3s; width: 100%;
  }
  .form-submit:hover { background: var(--wood-mid); }

  /* ── FOOTER ── */
  footer { background: #1A1008; position: relative; }
  .footer-links { flex-wrap: wrap; gap: 12px; justify-content: center; }
  .footer-links a {
    font-size: 12px; color: rgba(245,239,230,0.4);
    text-decoration: none; letter-spacing: 1px; transition: color 0.3s;
  }
  .footer-links a:hover { color: var(--wood-light); }
  .footer-copy { font-size: 12px; color: rgba(245,239,230,0.3); }
  .social-link { width:44px; height:44px; border:1px solid rgba(196,154,108,0.3); display:flex; align-items:center; justify-content:center; font-size:18px; cursor:pointer; transition:all 0.3s; text-decoration:none; color: var(--wood-light); }
  .social-link:hover { background:var(--wood-mid); border-color:var(--wood-mid); color: var(--cream); }

  /* ── HAKKIMIZDA PAGE ── */
  .about-page-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 64px; align-items: start; margin-top: 64px; }
  .about-page-grid img { width: 100%; }
  .values-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 32px; margin-top: 64px; }
  .value-card { padding: 40px 32px; background: var(--cream); border-bottom: 3px solid transparent; transition: border-color 0.3s; }
  .value-card:hover { border-color: var(--wood-light); }
  .value-icon { font-size: 32px; margin-bottom: 20px; }
  .value-card h3 { font-family: 'Playfair Display', serif; font-size: 20px; color: var(--wood-dark); margin-bottom: 12px; }
  .value-card p { font-size: 14px; color: var(--text-muted); line-height: 1.8; }
  .team-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 32px; margin-top: 48px; }
  .team-card { text-align: center; }
  .team-avatar { width: 100%; aspect-ratio: 1; background: linear-gradient(135deg, var(--wood-dark), var(--wood-mid)); margin-bottom: 16px; display: flex; align-items: center; justify-content: center; font-size: 48px; }
  .team-card h4 { font-family: 'Playfair Display', serif; font-size: 18px; color: var(--wood-dark); margin-bottom: 4px; }
  .team-card p { font-size: 13px; color: var(--text-muted); }
  .stats-bar { background: var(--wood-dark); padding: 64px 60px; display: grid; grid-template-columns: repeat(4,1fr); gap: 32px; text-align: center; }
  .stats-bar .stat-num { font-family: 'Playfair Display', serif; font-size: 48px; color: var(--wood-light); font-weight: 600; }
  .stats-bar .stat-label { font-size: 13px; color: rgba(245,239,230,0.5); letter-spacing: 1px; text-transform: uppercase; margin-top: 8px; }

  /* ── HİZMETLER PAGE ── */
  .services-page-grid { display: grid; grid-template-columns: repeat(2,1fr); gap: 2px; background: var(--cream); margin-top: 64px; }
  .service-page-card { background: var(--white); padding: 56px 48px; position: relative; overflow: hidden; transition: background 0.4s; cursor: pointer; }
  .service-page-card::after { content:''; position:absolute; bottom:0; left:0; width:0; height:4px; background:var(--wood-light); transition:width 0.4s; }
  .service-page-card:hover::after { width:100%; }
  .service-page-card:hover { background: var(--cream); }
  .service-page-num { font-family:'Playfair Display',serif; font-size:60px; color:rgba(196,154,108,0.12); font-weight:700; line-height:1; margin-bottom:16px; }
  .service-page-card h3 { font-family:'Playfair Display',serif; font-size:26px; color:var(--wood-dark); margin-bottom:16px; font-weight:600; }
  .service-page-card p { font-size:14px; color:var(--text-muted); line-height:1.9; }
  .service-page-card ul { margin-top:20px; padding-left:0; list-style:none; display:flex; flex-direction:column; gap:8px; }
  .service-page-card ul li { font-size:13px; color:var(--text-muted); padding-left:16px; position:relative; }
  .service-page-card ul li::before { content:'—'; position:absolute; left:0; color:var(--wood-light); }
  .process-steps { display:grid; grid-template-columns:repeat(4,1fr); gap:32px; margin-top:64px; }
  .process-step { text-align:center; padding:40px 24px; }
  .step-num { font-family:'Playfair Display',serif; font-size:56px; color:var(--wood-light); opacity:0.4; font-weight:700; line-height:1; margin-bottom:16px; }
  .process-step h4 { font-family:'Playfair Display',serif; font-size:18px; color:var(--wood-dark); margin-bottom:12px; }
  .process-step p { font-size:13px; color:var(--text-muted); line-height:1.8; }

  /* ── ÜRÜNLER PAGE ── */
  .products-page-grid { display:grid; grid-template-columns:repeat(3,1fr); gap:2px; background:var(--cream); margin-top:64px; }
  .product-page-card { background:var(--white); overflow:hidden; cursor:pointer; position:relative; }
  .product-page-img { aspect-ratio:1; overflow:hidden; }
  .product-page-color { width:100%; height:100%; display:flex; flex-direction:column; justify-content:flex-end; padding:32px; transition:transform 0.6s; }
  .product-page-card:hover .product-page-color { transform:scale(1.04); }
  .product-page-color h3 { font-family:'Playfair Display',serif; font-size:24px; color:var(--cream); font-weight:600; margin-bottom:8px; }
  .product-page-color p { font-size:13px; color:rgba(245,239,230,0.7); }
  .product-page-info { padding:24px; }
  .product-page-info p { font-size:13px; color:var(--text-muted); line-height:1.7; margin-top:8px; }
  .product-page-info .tag { display:inline-block; font-size:10px; letter-spacing:1.5px; text-transform:uppercase; background:var(--cream); color:var(--wood-mid); padding:4px 10px; margin-top:12px; }
  .filter-bar { display:flex; gap:12px; flex-wrap:wrap; margin-top:48px; }
  .filter-btn { background:transparent; border:1px solid rgba(196,154,108,0.3); padding:8px 20px; font-family:'Jost',sans-serif; font-size:12px; letter-spacing:1px; text-transform:uppercase; cursor:pointer; color:var(--text-muted); transition:all 0.3s; }
  .filter-btn:hover, .filter-btn.active { background:var(--wood-dark); color:var(--cream); border-color:var(--wood-dark); }

  /* ── İLETİŞİM PAGE ── */
  .contact-page-grid { display:grid; grid-template-columns:1fr 1.4fr; gap:80px; }
  .contact-map { width:100%; height:300px; background:linear-gradient(135deg,var(--wood-dark),var(--wood-mid)); margin-top:40px; display:flex; align-items:center; justify-content:center; gap:12px; text-decoration:none; }
  .social-links { display:flex; gap:16px; margin-top:32px; }

  /* ── ANIMATIONS ── */
  @keyframes fadeUp {
    from { opacity:0; transform:translateY(30px); }
    to   { opacity:1; transform:translateY(0); }
  }

  /* ── MOBILE RESPONSIVE ── */
  @media (max-width: 1024px) {
    nav { padding: 0 32px; }
    .section { padding: 80px 32px; }
    .hero { padding: 70px 32px 40px; }
    .page-hero { padding: 70px 32px 48px; }
    .services-grid { grid-template-columns: repeat(2,1fr); }
    .products-grid { grid-template-columns: repeat(2,1fr); }
    .about-inner { gap: 48px; }
    .team-grid { grid-template-columns: repeat(2,1fr); }
    .stats-bar { grid-template-columns: repeat(2,1fr); padding: 48px 32px; }
    .values-grid { grid-template-columns: repeat(2,1fr); }
    .process-steps { grid-template-columns: repeat(2,1fr); }
    .products-page-grid { grid-template-columns: repeat(2,1fr); }
    .contact-inner { grid-template-columns: 1fr; gap: 48px; }
    .contact-page-grid { grid-template-columns: 1fr; gap: 48px; }
    .testimonial { padding: 0 32px; }
  }

  @media (max-width: 768px) {
    nav { padding: 0 24px; }
    .nav-links, .nav-cta { display: none; }
    .hamburger { display: flex; }
    .section { padding: 64px 24px; }
    .hero { padding: 80px 24px 48px; min-height: auto; }
    .hero-img { display: none; }
    .hero h1 { font-size: 42px; }
    .hero-stats { gap: 24px; margin-top: 40px; padding-top: 32px; }
    .stat-num { font-size: 28px; }
    .page-hero { padding: 70px 24px 40px; min-height: 260px; }
    .page-hero h1 { font-size: 36px; }
    .section-title { font-size: 32px; }
    .services-header { flex-direction: column; align-items: flex-start; }
    .services-grid { grid-template-columns: 1fr; }
    .service-card { padding: 36px 24px; }
    .about-inner { grid-template-columns: 1fr; }
    .about-visual { display: none; }
    .products-header { flex-direction: column; align-items: flex-start; }
    .products-grid { grid-template-columns: repeat(2,1fr); gap: 16px; }
    .about-page-grid { grid-template-columns: 1fr; }
    .values-grid { grid-template-columns: 1fr; }
    .team-grid { grid-template-columns: repeat(2,1fr); }
    .stats-bar { grid-template-columns: repeat(2,1fr); padding: 40px 24px; }
    .stats-bar .stat-num { font-size: 36px; }
    .services-page-grid { grid-template-columns: 1fr; }
    .process-steps { grid-template-columns: repeat(2,1fr); }
    .products-page-grid { grid-template-columns: 1fr; }
    .contact-inner { grid-template-columns: 1fr; }
    .form-row { grid-template-columns: 1fr; }
    .testimonial { padding: 0 24px; height: auto; min-height: 400px; }
    .testimonial-text { font-size: 20px; }
    .quote-mark { font-size: 80px; }
    .footer-links { flex-wrap: wrap; gap: 16px; }
  }

  @media (max-width: 480px) {
    .hero h1 { font-size: 34px; }
    .hero-btns { flex-direction: column; }
    .btn-primary, .btn-outline { width: 100%; text-align: center; padding: 14px 20px; font-size: 11px; letter-spacing: 1px; }
    .products-grid { grid-template-columns: 1fr; }
    .team-grid { grid-template-columns: 1fr; }
    .process-steps { grid-template-columns: 1fr; }
    .stats-bar { grid-template-columns: 1fr; }
    .section-title { font-size: 28px; }
    .page-hero h1 { font-size: 30px; }
    .about-title, .contact-title { font-size: 28px !important; }
  }
`;

export default css;